export default {

  responsiblePerson: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  responsibleGroup: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/cobranca/modal/asign/addAsign-form.js